<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>손 쉽게 작성하는 아카데미 글</h1>
                        <p>고도의 학술적 글쓰기 지원을 통해 출판 성공률을 높여 보세요. 트링카는 학술적인 글쓰기에 준수하기 위한 최고의 툴로 여러분의 글의 품질을 더욱더 향상시킬 수 있습니다.
                        </p>
                        <button id="salesContactButtons" data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/academic.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>개별 맞춤형 솔루션
                        </h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>대학 및 학술 기관</li>
                            <li>단체 및 협회</li>
                            <li>연구개발기관</li>
                            <li>실험실</li>
                            <li>저널 & 출판물</li>
                            <li>도서관</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>글로벌
                        <br>사용자
                    </h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="clients" width="180">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/StanfordUniversity.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Caltech.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/MIT.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yale.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/UniversityOfTokyo.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="clients" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="clients" width="180">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>질 높은 학술적 글 쓰기를 위한 최고의 보조 툴</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 교수진과 학생들이 학업 수준에서 최고의 품질로 문서가 쉽고 기한내에 전달할 수 있도록 지원합니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublicationReadiness.svg" alt="publication-readiness-checks" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>출판 준비 확인</h3>
                                    <p>트링카는 20가지 이상의 출판 준비 요구 사항에 대해 연구 논문을 확인해 드립니다. 이로써 팀의 출판을 앞당겨 브랜드의 연구 포트폴리오를 더 빨리 강화할
                                        수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="medical" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>학술 맞춤법 검사 및 사전</h3>
                                    <p>트링카에 내장된 학술 사전에는 다양한 분야의 수천 가지에 이르는 용어가 수록되어 있습니다. 또한 본인의 소속 조직이 사용하는 어휘와 새 용어를 추가하여
                                        모든 커뮤니케이션에서 일관성을 유지하면서 글쓰기 지원 내용을 개인 맞춤화할 수 있습니다. </p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/StyleGuides.png" alt="style_guide" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>맞춤형 스타일 가이드 내장</h3>
                                    <p>트링카를 사용하면 AMA와 APA 같은 기술 스타일 가이드를 쉽게 준수할 수 있습니다. 클릭 몇 번이면 모든 글쓰기 기본 선호 설정을 수정할 수 있습니다.
                                        맞춤형 스타일 가이드를 사용하여 팀 간의 모든 커뮤니케이션도 표준화해 보세요.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublishReadywriting.png" alt="PublicationReadiness" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>출판 준비</h3>
                                    <p>트링카는 글이 객관성, 정확성, 격식에 맞는 어조 등 학문적 기준에 충족하는지 확인합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>표절 검사 </h3>
                                    <p>가장 진보된 텍스트 유사도 탐지 알고리즘인 iThenticate와 최대 규모의 유료 출판 데이터베이스를 통해 최고 품질의 표절 검사를 제공합니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/FileLevelRestrictions.svg" width="40" height="40" alt="file level" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>파일 수준 제어 </h3>
                                    <p>트링카의 세분화된 제어 기능을 통해 인하우스 학생과 원격 학습자의 액세스를 쉽고 안전하게 관리할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>종합 분석</h3>
                                    <p>효과적인 의사 결정을 위해 팀에서 트링카 사용방법 또는 풍부한 분석 기능을 사용하여 각 사용자의 활동을 상세하게 분석할 수 있습니다. </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy-use" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>간편한 사용자 관리</h3>
                                    <p>팀 계정을 사용하면 액세스 관리, 라이센스 교환 또는 구성원을 손 쉽게 추가할 수 있으며 다른 기능은 자동화할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="DedicatedSupport" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>전담 지원</h3>
                                    <p>전담 매니저가 배정되어 전화, 문서, 그리고 영상 등을 통해 트링카를 최대한 활용할 수 있도록 지원합니다.
                                    </p>
                                </div>
                            </div>
                        </li>



                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="bulk-editing" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>대량 교정 작업</h3>
                                    <p>문서를 MS Word 형식으로 업로드하고 편안히 앉아 몇 분만 기다리면 트링카가 문서를 교정해 드립니다. 변경 사항이 추적 및 적용되어 교정이 끝난 파일을
                                        다운로드하여 검토하고 마무리 지으면 됩니다. </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>
                    <span class="bottom_diviedLine2"></span>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>모든 사용자 사례 지원</h2>
                    <div class="HeadingSubLine"></div>
                    <p>트링카는 학술기관의 가이드에 맞춰 모든 것을 지원합니다.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>학습 진도 추적</h4>
                                <p>풍부한 통찰력으로 개별 학생의 시간 경과에 따른 글쓰기 향상을 평가하고 추적합니다.
                                </p>
                                <ul>
                                    <li>글 품질점수</li>
                                    <li>문법 카테고리별 오류</li>
                                    <li>수정된 사항</li>
                                    <li>글쓰기 참여도</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>학생들이 학술적 글쓰기 기술을 향상하도록 지원</h4>
                                <p>트링카는 오류에 대한 자세한 설명을 제공하여 글 작성자가 학술적 글쓰기 관행을 배울 수 있게 도와드립니다.
                                </p>
                                <ul>
                                    <li>복잡한 작문 오류 찾기</li>
                                    <li>수정 사항에 대한 자세한 설명 제공</li>
                                    <li>글쓰기 향상을 위한 팁 제공</li>
                                    <li>발전 양상을 추적할 수 있는 글 품질 점수 제공</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>연구원의 빠른 출판 지원</h4>
                                <p>트링카는 편집상 이유로 거절당하는 일을 피하고 글로벌 저널에 더 빨리 출판하는 데 도움을 드리도록 설계되었습니다.</p>
                                <ul>
                                    <li>기술적합성 체크(논문 구조 및 완성도)</li>
                                    <li>저널 범위 확인(적합한 저널 찾기에 도움)</li>
                                    <li>스타일 가이드 내장</li>
                                    <li>키워드 제안</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>MS Word 파일 자동 교정</h4>
                                <p>트링카를 사용하면 모든 문서를 한 번에 업로드하고 몇 분 안에 자동으로 교정할 수 있습니다.</p>
                                <ul>
                                    <li>완전 제어 가능한 파일 변경내용 추적</li>
                                    <li>글 품질점수 및 카테고리별 오류 보고서</li>
                                    <li>글쓰기 개선 사항을 빠르게 적용하여 몇 분 안에 교정 가능</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>독점 소프트웨어 및 작업 흐름에 따른 통합
                    </h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>트링카는 간단한 통합으로 기존 소프트웨어 내의 모든 이점을 다양한 플랫폼에서도 글이 생산적이고 효율적이게 글이 작성될 수 있도록 지원합니다.
                </p>
            </div>
        </div>
        <div class="row">

            <div class="col-md-4">
                <div class="features_cards">

                    <h3>클라우드 에디터</h3>


                    <p>
                        안전한 웹 기반 애플리케이션을 통해 어디에서나 트링카의 잠재력을 최대로 활용해 보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>MS Word 추가 기능</h3>
                    <p>
                        MS Word 내에서 글쓰기 제안이 전달되도록 하여 팀의 생산성을 높여보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>브라우저 플러그인</h3>
                    <p>
                        즐겨 사용하는 모든 브라우저에 적합한 플러그인을 통해 모든 웹사이트에서 실시간 글쓰기 지원을 받아보세요.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>귀사에 적합한 맞춤형 비용</h2>
                </div>
                <p>트링카는 고객 고유의 요구사항에에 맞게 개별 사용자 또는 사용 용도에 따른 비용을 책정합니다.
                    <br>추가 비용 없이 사용자를 변경하고 사용 제한을 실시간으로 적용할 수 있습니다.
                    <br>고객과 협력하여 주문서 및 인보이스를 통해 개별 맞춤형 계약 및 단일 결제 옵션이 제공될 수 있도록 협력합니다.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 없습니다.
                            <br>트링카는 글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은
                            <br>언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>트링카로 비즈니스 커뮤니케이션을 혁신해 보세요</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">견적 문의</button>
</div>

<app-enterprise-modal></app-enterprise-modal>